module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('custom-form', {
    attrs: {
      "fields": ['username', 'email', 'firstname', 'lastname', 'password', 'password_repeat'],
      "submitLabel": "Registrieren",
      "secondaryLabel": "Bestehendes Konto verwenden",
      "url": "signup"
    },
    on: {
      "submitted": function($event) {
        _vm.signedUp()
      },
      "secondary": function($event) {
        _vm.login()
      }
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('h1', [_vm._v("Registrieren")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ee3a5454","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/signup.vue
// module id = 241
// module chunks = 0